export const MinusIcon = ({ className }) => (
   <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
   <g id="icons / bx-minus">
   <path id="Vector" d="M3.33398 7.3335H12.6673V8.66683H3.33398V7.3335Z" fill="currentColor"/>
   </g>
   </svg>
)